import React, {Component} from "react";
import {getTableConfig} from "./config";
import {yearOptions} from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleUploadImage from "../../../../../modules/upload/SimpleUploadImage";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import CardBartChart from "../../../../../cards/SimpleBarchart";
import { HttpStatus } from "../../../../common/Constants";
import * as R from "ramda";
import {parseDataChartYearToDate, parseDataChartLast3Year, parseDataKey, parseDataKeyL3Y} from './service'
class SalesmanStructureReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: null,
            tableConfig: getTableConfig(this.props.tab),
            dataTable: [],
            chartVisible: false,
            showVolume: true,
            chartPercentage: "",
            chartVolume: "",
            dataPercentage: [],
            dataChart: []
        };
    };

    componentDidMount = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            year: yearOptions.find(item => item.value === new Date().getFullYear()),
            tableConfig: getTableConfig(this.props.tab),
        }), ()=>{
            if(this.props.search){
                this.fetchData();
            }
        });
    };


    
    componentDidUpdate(prevProps, prevState) { 
        if(!R.equals(this.props.search, prevProps.search)){
            this.fetchData();
        }
    } 

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleSearch = () => {
        this.setState(prev=>({
            ...prev,
            tableConfig: getTableConfig(this.props.tab, prev.year?.value),
        }), () => this.fetchData())
    };

    transformLast3YearResponse = (data) => {
        const transformed = data.map((item) => {
          const { dataQuartal = {}, ...rest } = item;
          return {
            ...rest,
            ...dataQuartal,
          };
        });
        return transformed;
    };

    transformMTDResponse = (data) => {
        return [
          { name: "cs", ...data.cs, totalPayment: data.totalCS },
          { name: "sales", ...data.sales, totalPayment: data.totalSales },
          { name: "office", ...data.office, totalPayment: data.totalOffice },
        ];
    };

    fetchData = async () => {
        const { handleTriggerLoading, search, isAllSelected, dataCabang, setError, tab } = this.props
        handleTriggerLoading();
        let dataKodeCabang = search;
        if(isAllSelected){
          dataKodeCabang = dataCabang.map((item) => item.kodeCabang)
        }
        const asyncFn = tab === 'mtd' ?
        Api.create("NAGAMAS_REPORT_DTO").getLaporanStrukturCSSalesmanTahunBerjalan :
        Api.create("NAGAMAS_REPORT_DTO").getLaporanStrukturCSSalesmanLastThreeYear;
        
        const res = await fetchDataAsync({
          asyncFn: asyncFn,
          setError: setError,
          menuName: "Dashboard Sales - Laporan Penjualan 3 Tahun Terakhir",
          args: {
            kodeCabang: dataKodeCabang,
            year: this.state.year?.value,
            employeeIdTeamLeader: this.props.idLeader,
          },
        });
        handleTriggerLoading();
        
        const parseDataChartFunction =
                tab === "mtd"
                  ? parseDataChartYearToDate
                  : parseDataChartLast3Year; 
        const dataChart = parseDataChartFunction(res.data.data, true, this.state.year?.value);
        const dataPercentage = parseDataChartFunction(res.data.data, false, this.state.year?.value);

        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            this.setState((prevValue) => ({
              ...prevValue,
              dataTable: tab === 'mtd' ?
                this.transformMTDResponse(res.data.data) :
                this.transformLast3YearResponse(res.data.data),
              dataKey: tab === "mtd" ?
                parseDataKey(res.data.data):
                parseDataKeyL3Y(res.data.data),
             dataChart: dataChart,
             dataPercentage: dataPercentage
            }));
        }
            
    };

    handleChartVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            chartVisible: !prevValue.chartVisible,
        }));
    };

    handleChangeChart = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            showVolume: !prevValue.showVolume,
        }));
    };

    render() {
        const { dataChart, dataKey, showVolume, dataPercentage } = this.state
        return(
            <>
                <FlexView style={{gap: "20px", alignItems: "center"}}>
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        name="year"
                        isClearable
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        styles={{marginBottom: "15px"}}
                        onClick={()=>this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                {!this.state.chartVisible && (
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.state.tableConfig}
                        options={{pagination: false}}
                    />
                )}
                {this.state.chartVisible && (
                    <div>
                      <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
                        Chart By {showVolume ? "Volume" : "Percentage"}
                      </p>
                      {showVolume && <CardBartChart data={dataChart} dataKey={dataKey} />}
                      {!showVolume && (
                        <CardBartChart data={dataPercentage} dataKey={dataKey} yAxisType="percentage"/>
                      )}
                    </div>
                )}
                <FlexView style={{justifyContent: "end", marginTop: "15px"}}>
                    <SimpleButton onClick={this.handleChartVisibility}>Chart</SimpleButton>
                    {this.state.chartVisible && (
                        <SimpleButton onClick={this.handleChangeChart}>{`Percentage /\n Volume`}</SimpleButton>
                    )}
                </FlexView>
            </>
        );
    };
}

export default SalesmanStructureReport;